"use strict";
function isFunction(value) {
  return typeof value === "function";
}
function isString(value) {
  return typeof value === "string";
}
function isNumber(value) {
  return typeof value === "number";
}
function isArray(value) {
  return Array.isArray(value);
}
function isObject(value) {
  return value === Object(value) && !isArray(value) && !isFunction(value);
}
function isNil(value) {
  return value === void 0 || value === null;
}
export {
  isArray,
  isFunction,
  isNil,
  isNumber,
  isObject,
  isString
};
